import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class TimeZoneService {
  public timezones = [
    { name: 'GMT+12', value: 720 },
    { name: 'GMT+11', value: 660 },
    { name: 'GMT+10', value: 600 },
    { name: 'GMT+9', value: 540 },
    { name: 'GMT+8', value: 480 },
    { name: 'GMT+7', value: 420 },
    { name: 'GMT+6', value: 360 },
    { name: 'GMT+5', value: 300 },
    { name: 'GMT+4', value: 240 },
    { name: 'GMT+3', value: 180 },
    { name: 'GMT+2', value: 120 },
    { name: 'GMT+1', value: 60 },
    { name: 'GMT 0', value: 0 },
    { name: 'GMT-1', value: -60 },
    { name: 'GMT-2', value: -120 },
    { name: 'GMT-3', value: -180 },
    { name: 'GMT-4', value: -240 },
    { name: 'GMT-5', value: -300 },
    { name: 'GMT-6', value: -360 },
    { name: 'GMT-7', value: -420 },
    { name: 'GMT-8', value: -480 },
    { name: 'GMT-9', value: -540 },
    { name: 'GMT-10', value: -600 },
    { name: 'GMT-11', value: -660 },
    { name: 'GMT-12', value: -720 },
  ];

  getTimeZoneName(offset: number | string): string {
    const minutes = Number(offset);
    const tzObj = this.timezones.find(t => t.value === minutes);
    return tzObj!.name;
  }

  get timeZone(): string | null {
    const saved = localStorage.getItem('tz');
    if (!saved) return null;

    const tzObj = this.timezones.find(t => t.value === Number(saved));
    return tzObj?.name ?? null;
  }

  getTimeZone(): string {
    const idToken = localStorage.getItem('tz');
    return this.getTimeZoneName(idToken!);
  }
}
